import { __rest } from 'tslib';
import React from 'react';
import { space } from 'styled-system';
import { a as styled } from './styled-112a8bd0.js';
import { I as Input } from './Input-45f6a70c.js';

const getColor = (props) => {
    switch (props.variant) {
        case 'invalid':
            return '#dc3545';
        case 'valid':
            return '#28a745';
    }
};
const Label = styled.div `
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 4px;
  font-size: 13px;
`;
const Feedback = styled.div((props) => {
    const styles = {};
    if (getColor(props)) {
        styles.color = getColor(props);
        styles.marginTop = '0.25rem';
    }
    return styles;
});
const StyledInput = styled(Input)((props) => {
    const styles = {};
    styles.height = `40px`;
    if (getColor(props)) {
        styles.borderColor = `${getColor(props)} !important`;
    }
    return styles;
});
const Wrapper = styled.div(space);
const FormInput = (_a) => {
    var { label, feedback, variant } = _a, props = __rest(_a, ["label", "feedback", "variant"]);
    return (React.createElement(Wrapper, Object.assign({}, props),
        label && React.createElement(Label, { className: "form-input__label" }, label),
        React.createElement(StyledInput, Object.assign({}, props, { variant: variant, className: "form-input__input" })),
        feedback && React.createElement(Feedback, { variant: variant }, feedback)));
};

export { FormInput as F };
